import React from 'react';
import { PageHeader } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {}

export function Forecast(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Meteo.Forecast', 'Forecast')}
      />
      <S.Wrapper>
        <S.IFrame
          // width="650"
          // height="450"
          src="https://embed.windy.com/embed2.html?lat=52.349&lon=25.313&detailLat=54.693&detailLon=25.299&width=650&height=450&zoom=5&level=surface&overlay=wind&product=ecmwf&menu=&message=&marker=&calendar=24&pressure=&type=map&location=coordinates&detail=true&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1"
          frameBorder="0"
        ></S.IFrame>
      </S.Wrapper>
    </>
  );
}

const S = {
  Wrapper: styled.div`
    height: calc(100% - 75px);
    background: #e6f7ff;
  `,
  IFrame: styled.iframe`
    height: 100%;
    width: 100%;
  `,
};
